<template>
  <div class="footer">
    <div class="footer-container">
    <div class="container">
      <div class="footer-left">
        <div>
          <img src="@/assets/img/baisejingyu.png" alt="" srcset="">
          <div>数字鲸鱼</div>
        </div>
        <div style="margin-top: 20px;">
          <img src="@/assets/icon/tqq.png" alt="">
          <img src="@/assets/icon/weibo.png" alt="">
          <img src="@/assets/icon/weixin.png" alt="">
        </div>
      </div>
      <div class="footer-right" v-for="(item,index) in pageData" :key="index">
        <div class="footer-item" :class="[index == 3?'fourWidth':'']">
          <div class="footer-title">{{ item.title }}</div>
          <div v-for="(e,i) in item.list">{{ e }}</div>
        </div>
        <!-- <div class="footer-item">
          <div class="footer-title">关于鲸鱼</div>
          <div>公司简介</div>
          <div>发展历程</div>
          <div>创始团队</div>
          <div>荣誉资质</div>
        </div>
        <div class="footer-item">
          <div class="footer-title">产品与服务</div>
          <div>电力巡检</div>
          <div>智能仓储</div>
          <div>数字孪生</div>
          <div>智慧能源</div>
          <div>电网业务系统</div>
          <div>服务过程</div>
          <div>服务优势</div>
        </div>
        <div class="footer-item">
          <div class="footer-title">其他</div>
          <div>隐私条款</div>
          <div>版权声明</div>
        </div> -->
        <!-- <div class="footer-item" style="width: 240px;">
          <div class="footer-title">联系我们</div>
          <div>联系电话：0531-81766608</div>
          <div>周一至周五（9:00-18:00）</div>
          <div>邮箱：services@digitalwhale.com.cn</div>
          <div>地址：山东省济南市历下区文化东路55号泰山科技大厦7楼整层</div>
        </div> -->
      </div>
    </div>
    <div class="bottom">{{ company }}  版权所有  
    <a :href="hrefUrl" target="_blank">{{ count }}</a>
    </div>
  </div>
  </div>
</template>

<script>
import jsonData from '../../../../public/static/text.json';
export default {
  data() {
    return {
      pageData: [],
      company: "",
      count: "",
      hrefUrl:""
    }
  },
  mounted(){
    this.pageData = jsonData.oneData.footerPart.list
    this.company = jsonData.oneData.footerPart.company
    this.count = jsonData.oneData.footerPart.count
    this.hrefUrl = jsonData.oneData.footerPart.hrefUrl
  }
}
</script>

<style lang="less" scoped>
// 页脚样式
.footer {
  width: 100%;
  height: 430px;
  background-color: #262a36;
  .footer-container {
    width: 1380px;
    height: 430px;
    margin: 0 auto;
    padding: 0 50px;
    overflow-x: auto;
    min-width: 1380px;
  .container {
    width: 100%;
    height: 320px;
    display: flex;
    .footer-left {
      height: 100%;
      width: 300px;
      padding-top: 30px;
      box-sizing: border-box;
      margin-right: 300px;
      >div {
        height: 60px;
        display: flex;
        img{
          width: 60px;
          height: 60px;
        }
        div{
          width: 160px;
          height: 60px;
          font-size: 32px;
          font-family: PingFang SC, PingFang SC-400;
          font-weight: 500;
          text-align: LEFT;
          color: #ffffff;
          line-height: 60px;
          margin-left: 10px;
        }
      }
    }
    .footer-right {
      height: 100%;
      display: flex;
      text-align: left;
      padding-top: 30px;
      .footer-item {
        width: 120px;
        margin-right: 40px;
        .footer-title{
          height: 40px;
          font-size: 16px;
          color: #ffffff;
          line-height: 40px;
        }
        >div {
          height: 20px;
          font-size: 14px;
          font-family: 'Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-250';
          color: #b1b2b2;
          line-height: 20px;
          margin-top: 10px;
        }
      }
      .fourWidth {
        width: 240px;
        margin-right: 0;
      }
    }
  }
  .bottom {
    width: 100%;
    height: 20px;
    padding: 20px 0;
    font-size: 14px;
    font-family: 'Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 2.0-250';
    color: #b1b2b2;
    line-height: 20px;
    border-top: 1px solid #454b60;
    a{
      text-decoration: none;
      color: #b1b2b2;
    }
    a:active{
      color: #fff;
    }
    
  }
}
}
</style>